/**
 * Centralized z-index values for consistent layering.
 *
 * Usage:
 * import { zIndex } from '../constants/zIndex';
 * sx={{ zIndex: zIndex.tooltip }}
 */
export const zIndex = {
  base: 0,
  raised: 1,
  stickyTableHeader: 3,
  header: 100,
  dropdown: 1000,
  sticky: 1100,
  overlay: 1200,
  modal: 1300,
  popover: 1400,
  tooltip: 1500,
} as const;

export type ZIndexKey = keyof typeof zIndex;
